import { defineStore } from "pinia";

const isShowAlertMguu = ref(false);
const showAlertMguuTextMessage = ref('');

const useAlertMguuStore = defineStore('alertmguu-store', () => {

    return {
        isShowAlertMguu,
        showAlertMguuTextMessage
    }
})

export default useAlertMguuStore;